import { useId } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './Radio.module.scss';

export interface RadioOption {
  value: string;
  label: string;
  hint?: string;
  disabled?: boolean;
}

export interface RadioGroupProps {
  /** Rotulo do conjunto. Vira a legenda do `fieldset`. */
  legend: string;
  name: string;
  options: readonly RadioOption[];
  value?: string;
  onChange?: (value: string) => void;
  /** Dispoe as opcoes lado a lado. Use so com rotulos curtos. */
  inline?: boolean;
  className?: string;
}

/**
 * Grupo de escolha unica.
 *
 * Renderiza `fieldset` + `legend` em vez de um rotulo solto: e o que faz o leitor
 * de tela anunciar a pergunta antes de cada opcao.
 */
export function RadioGroup({ legend, name, options, value, onChange, inline, className }: RadioGroupProps) {
  const id = useId();

  return (
    <fieldset className={cn(styles.group, className)}>
      <legend className={styles.legend}>{legend}</legend>
      <div className={cn(styles.options, inline && styles.inline)}>
        {options.map((option) => {
          const optionId = `${id}-${option.value}`;
          return (
            <div key={option.value} className={styles.option}>
              <input
                id={optionId}
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                disabled={option.disabled}
                onChange={(event) => onChange?.(event.target.value)}
                className={styles.input}
              />
              <label htmlFor={optionId} className={styles.label}>
                {option.label}
              </label>
              {option.hint ? <p className={styles.hint}>{option.hint}</p> : null}
            </div>
          );
        })}
      </div>
    </fieldset>
  );
}
